export default __webpack_public_path__ + "static/media/bio2.4185e31a.JPG";